import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import "./App.css";
import MainRoutes from "./routing/MainRoutes";
import { AuthProvider, getUser, useAuth } from "./context/authContext";
import Loader from "react-js-loader";

function App() {
  const [auth, setAuth] = useState(false);
  const [isLoading, setLoading] = useState(true);

  // const location = useLocation();
  if (process.env.NODE_ENV === "production") {
    // Disable all console methods in production
    console.log = console.info = console.warn = console.error = () => {};
  }

  useEffect(() => {
    async function fetchData() {
      const authData = await getUser();
      // console.log(authData, "authData");
      setAuth(authData);
      setLoading(false);
    }
    fetchData();
  }, []);

  return isLoading ? (
    <div className="row">
      <div className="item">
        <Loader
          type="spinner-circle"
          bgColor={"#000"}
          title={"Loading"}
          color={"#000"}
          size={100}
        />
      </div>
    </div>
  ) : auth ? (
    <AuthProvider myAuth={auth}>
      <MainRoutes />
    </AuthProvider>
  ) : (
    <Navigate to="/login" replace />
  );
}

export default App;
